import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Shield, Package, TrendingUp, DollarSign } from "lucide-react";
import { ArrowRight } from 'react-bootstrap-icons';
import { useNavigate } from "react-router-dom/dist";
import { useDispatch } from "react-redux";
import { setFromLandingPage } from "../../../Redux/landingPageSlice"
import { trackEvent } from "../../../analytics";


const HeroSection = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const stats = [
        { number: "40,000+", label: "Avg Monthly Earnings" },
        { number: "10k+", label: "Active Lenders" },
        { number: "4.8★", label: "Lender Rating" },

    ];

    const handleStartClick = () => {
        dispatch(setFromLandingPage(true))
        trackEvent('User Interaction', 'Open Popup', 'Login Popup');

        document?.getElementById("headerlogin").click();
    }

    return (
        <section
            className="gradient-section"
            style={{ paddingTop: "5rem", paddingBottom: "5rem" }}
        >
            <Container>
                <Row className="align-items-center ">
                    <Col lg={6}>
                        <div className="mb-4">
                            <div
                                className="d-inline-flex align-items-center px-3 py-2 rounded-pill mb-2 text-dark-green bg-light-green"

                            >
                                <span className="fw-medium small">💰 Start Earning Today </span>
                            </div>

                            <h1
                                className="fw-bold mb-2"
                                style={{ color: "var(--text-dark)", lineHeight: "1", fontSize: '60px', letterSpacing: "-3px" }}
                            >
                                Turn Your Items Into{" "}
                                <span className="text-green d-block">Income</span>
                            </h1>

                            <p
                                className="fw-400 mb-4 text-gray"
                                style={{
                                    fontSize: "20px",
                                    lineHeight: "28px",
                                }}
                            >
                                Join thousands of lenders earning extra money by renting out
                                items they already own. From tools to electronics, cameras to
                                outdoor gear - start monetizing your belongings today.
                            </p>
                        </div>

                        <div className="d-flex flex-column flex-sm-row gap-3 mb-5">
                            <Button size="lg" onClick={handleStartClick} className="start-lending-btn d-flex align-items-center justify-content-between py-3 px-4" >
                                Start Lending Now
                                <ArrowRight />
                            </Button>

                            <Button
                                size="lg"

                                className="see-how-btn hover:text-white px-4 py-2"
                                onClick={() => trackEvent('User Interaction', 'Scroll to Section', 'How It Works')
                                }

                            >
                                <a href="#how-it-works" className="text-green" >

                                    See How It Works

                                </a>
                            </Button>
                        </div>

                        {/* Stats */}
                        <Row className="g-4 text-center">
                            {stats.map((stat, index) => (
                                <Col xs={4} md={3} key={index}>
                                    <div className="text-center text-green">
                                        <div
                                            className="h4 fw-bold mb-1"

                                        >
                                            {stat?.number}
                                        </div>
                                        <div
                                            className="small fw-medium text-gray"

                                        >
                                            {stat?.label}
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>

                    {/* Right Content - Circular Earning Badge */}
                    <Col lg={6} className="text-center mt-3">
                        <div className="position-relative d-inline-block">
                            <div
                                className="hero-circle rounded-circle d-flex align-items-center justify-content-center shadow-lg"
                                style={{ width: "320px", height: "320px" }}
                            >
                                <div className="text-center text-white">
                                    {/* <div className="display-3  mb-2">$</div> */}
                                    <DollarSign size={80} />
                                    <div className="h4 fw-bold">Earn More</div>
                                    <div className="small opacity-75">with your items</div>
                                </div>
                            </div>

                            {/* Floating Elements */}
                            <div
                                className="position-absolute bg-white rounded-circle d-flex align-items-center justify-content-center shadow animate-bounce delay-100"
                                style={{
                                    top: "-16px",
                                    right: "0px",
                                    width: "48px",
                                    height: "48px",
                                }}
                            >
                                <TrendingUp size={24} className="text-dark-green" />
                            </div>
                            <div
                                className="position-absolute bg-white rounded-circle d-flex align-items-center justify-content-center shadow animate-bounce delay-300"
                                style={{
                                    bottom: "-16px",
                                    left: "16px",
                                    width: "48px",
                                    height: "48px",
                                }}
                            >
                                <Shield size={24} className={"text-dark-green"} />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default HeroSection;
